import { classes, debounce, getTargets, parseHTML } from '~/helpers';
import { HTMLCustomElement } from '~/html-custom-element';

if (!customElements.get('search-drawer'))
  customElements.define(
    'search-drawer',
    class SearchDrawer extends HTMLCustomElement {
      connectedCallback() {
        if (super.connectedCallback) super.connectedCallback();

        this.controller = new AbortController();

        this.on('keyup', this.targets.input, debounce(this.search.bind(this)));

        this.subscribe('toggle-element-opening', ({ id }) => {
          if (id === 'search-drawer') {
            if (this.targets.input.value) {
              this.search();
            }

            requestAnimationFrame(() => {
              this.targets.input.focus();
              this.targets.input.setSelectionRange(this.targets.input.value.length, this.targets.input.value.length);
            });
          }
        });
      }

      /**
       * Runs the search query and updates.
       */
      search() {
        const formData = new FormData(this.targets.form);

        formData.append('section_id', 'search-drawer');

        if (this.controller) {
          /**
           * Cancel the previous request.
           */
          this.controller.abort('Aborted pending search');
        }

        this.controller = new AbortController();

        try {
          fetch(`${theme.routes.search_url}?${new URLSearchParams(formData).toString()}`, {
            signal: this.controller.signal,
          })
            .then((response) => response.text())
            .then((response) => {
              const section = parseHTML(response, this.tagName.toLowerCase());

              if (section) {
                this.update(section);
              }
            });
        } catch (error) {
          console.error(error);
        }
      }

      /**
       * Updates the results.
       * @param {HTMLCustomElement} section - The section element.
       */
      update(section) {
        const { results, footer, terms } = getTargets(section) || {};

        this.targets.results.innerHTML = results.innerHTML;
        this.targets.footer.classList = footer.classList;
        this.targets.terms.classList = terms.classList;
      }
    }
  );
